import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/App.css';

// Suppress cross-origin "Script error." from third-party iframes (Google OAuth, reCAPTCHA, PayPal).
// These errors carry no useful information and cannot be handled — the browser hides all details
// intentionally for security (CORS). Only active in development; in production they don't show anyway.
if (process.env.NODE_ENV === 'development') {
    const originalOnError = window.onerror;
    window.onerror = function (message, source, lineno, colno, error) {
        if (message === 'Script error.' || message === 'Script error') {
            // Silently ignore: comes from cross-origin scripts (Google, PayPal, reCAPTCHA)
            return true; // tells the browser we "handled" it — suppresses the React overlay
        }
        // For all other errors, use default behaviour
        if (originalOnError) return originalOnError(message, source, lineno, colno, error);
        return false;
    };
}

const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);